import React, {useEffect, useState} from "react";
import "./Dashboard.css";
import "./Sidebar.js";
import Header from "../layout/header";
import BottomMenu from "../layout/bottomMenu";
import DashboardMenu from "../layout/dashboardMenu";
import {Chart} from "react-google-charts";
import axios from "axios";
import Loader from "../../Loader/Loader";
import { FunnelChart } from 'react-funnel-pipeline'
import 'react-funnel-pipeline/dist/index.css'
import $ from 'jquery'
import CanvasJSReact from './CanvasChart/canvasjs.react';
import Config from "../../service/Config/config";
import callWebService, {callTypes} from "../../../src/service/Networks/network.js";

var CanvasJSChart = CanvasJSReact.CanvasJSChart;

const Dashboard = ({history = null}) => {

    const [dashboardContent, setDashboardContent] = useState([])
    const [pieChartData, setPieChartData    ] = useState([['Account', 'Type']])
    const [opportunityPieChartData, setOpportunityPieChartData] = useState([['Opportunity', 'Type']])
    const [barChartData, setBarChartData] = useState([["Element", "Leads", { role: "style" }]])
    const [open, setOpen] = useState(false);
    const [isLoading, setIsLoading] = useState(false)
    const [filterInputList, setFilterInputList] = useState([{}])
    const [filterView, setfilterView] = useState([{}])
    const [isFilterRemove, setIsRemoveFilter] = useState(false)
    const [totalGate, setTotalGate] = useState(0)
    const [totalProposalQuantity, setTotalProposalQuantity] = useState(0)
    const [totalCommercialQuantity, setTotalCommercialQuantity] = useState(0)
    const [totalClosureQuantity, setTotalClosureQuantity] = useState(0)
    const [totalProposalSend, setTotalProposalSend] = useState(0)
    const [totalCommercialSend, setTotalCommercialSend] = useState(0)
    const [totalClosureSend, setTotalClosureSend] = useState(0)


    var chart;
    useEffect(() => {
        handleCallDashboardApis(`${Config?.dashboardContent}`)
    }, [])
    
    useEffect(() => {
        const disablePrintScreen = (event) => {
          if (event.key === 'PrintScreen') {
            event.preventDefault();
            alert('Screenshot is disabled!');
          }
        };
    
        window.addEventListener('keyup', disablePrintScreen);
        return () => {
          window.removeEventListener('keyup', disablePrintScreen);
        };
      }, []);

    const handleCallDashboardApis = async (url) => {
        var token = localStorage.getItem('token')
        var config = {headers: {"Content-Type": "application/json", 'Authorization': token}};
        const base_url = process.env.REACT_APP_API_URL;
        const {data} = await callWebService(callTypes.get, '',`${Config?.dashboardContent}`);

        if (data.response.data) {
            setDashboardContent(data.response)
        }
    }

    useEffect(() => {
        if(dashboardContent && dashboardContent?.data !== undefined){
            setPieChartData([['Account', 'Type']])
            /* eslint-disable */
            dashboardContent?.data?.stages.map((val, i) => {
                pieChartData.push([val?.name, val?.total])
                barChartData[barChartData.length] = [val?.name, val?.total, "color:"+val?.color]
            })

            dashboardContent?.data?.opportunity_stages.map((val, i) => {
                opportunityPieChartData.push([val?.name, val?.total])
            })
            setPieChartData(pieChartData)
            setBarChartData(barChartData)
            setOpportunityPieChartData(opportunityPieChartData)

            // if(dashboardContent?.data?.total_gate !== undefined){
            //     setTotalGate(dashboardContent?.data?.total_gate)
            // }

            if(dashboardContent?.data?.total_proposal_funnel_gate_quantity !== undefined){
                setTotalProposalQuantity(dashboardContent?.data?.total_proposal_funnel_gate_quantity)
            }

            if(dashboardContent?.data?.total_commercial_funnel_gate_quantity !== undefined){
                setTotalCommercialQuantity(dashboardContent?.data?.total_commercial_funnel_gate_quantity)
            }

            if(dashboardContent?.data?.total_closure_funnel_gate_quantity !== undefined){
                setTotalClosureQuantity(dashboardContent?.data?.total_closure_funnel_gate_quantity)
            }

            // if(dashboardContent?.data?.total_closure_send !== undefined){
            //     setTotalClosureSend(dashboardContent?.data?.total_closure_send)
            // }
            //
            // if(dashboardContent?.data?.total_commercial_send !== undefined){
            //     setTotalCommercialSend(dashboardContent?.data?.total_commercial_send)
            // }
            //
            // if(dashboardContent?.data?.total_proposal_send !== undefined){
            //     setTotalProposalSend(dashboardContent?.data?.total_proposal_send)
            // }
        }
        setTimeout(() => {
            setIsLoading(true)
            setIsLoading(false)
        }, 200)
    }, [dashboardContent])

    const handleFilter = async (key, value, stringValue = '') => {

        const list = [...filterInputList]
        const view = [...filterView]
        list[0][key] = value
        view[0][key] = value
        if (stringValue !== '') {
            view[0][key] = stringValue
            setfilterView(view)
        } else {
            setfilterView(view)
        }
        setFilterInputList(list)
    }

    const handleSubmitFilter = async () => {
        setOpen(false)
        setIsLoading(true)
        setPieChartData([['Account', 'Type']])
        setOpportunityPieChartData([['Opportunity', 'Type']])
        let url = `/api/v1/lead-squared/dashboard-content`
        Object.keys(filterInputList[0]).map((val, i) => {
            if(i === 0){
                url+="?"+val+"="+filterInputList[0][val]
            }else{
                url+="&"+val+"="+filterInputList[0][val]
            }
        })
        handleCallDashboardApis(url)
        setIsLoading(false)
    }

    const handleRemoveFilter = async (key) => {
        if (key !== '') {
            delete filterView[0][key]
            delete filterInputList[0][key]
            delete filterInputList[0][key + "_name"]
            setfilterView(filterView)
            setFilterInputList(filterInputList)
            setIsLoading(true)
            setPieChartData([['Account', 'Type']])
            setOpportunityPieChartData([['Opportunity', 'Type']])
            let url = `/api/v1/lead-squared/dashboard-content`
            Object.keys(filterInputList[0]).map((val, i) => {
                if(i === 0){
                    url+="?"+val+"="+filterInputList[0][val]
                }else{
                    url+="&"+val+"="+filterInputList[0][val]
                }
            })
            handleCallDashboardApis(url)
            setIsLoading(false)
        }
    }

    useEffect(() => {
        (async () => {
            if (isFilterRemove) {
                setfilterView([{}])
                setFilterInputList([{}])
                setIsLoading(true)
                setPieChartData([['Account', 'Type']])
                setOpportunityPieChartData([['Opportunity', 'Type']])
                handleCallDashboardApis(`/api/v1/lead-squared/dashboard-content`)
                setIsLoading(false)
                setIsRemoveFilter(false)
            }
        })()
    }, [isFilterRemove])

    const data = [["Account","Type"],["Client",3],["Open",3],["Draft",12],["Meeting Done",11],["Proposal Sent",2],["Lost-Not Converted/Dropped",1]];

    const options = {
        title: "",
        is3D: true,
        legend: {position: 'bottom', alignment: 'start'}
    };

    // var dataPoint;
    // var total;
    // const canvasOptions = {
    //     theme: "white",
    //     animationEnabled: true,
    //     title:{
    //         text: ""
    //     },
    //     data: [{
    //         type: "funnel",
    //         indexLabel: "{label} - {y}",
    //         // toolTipContent: "<b>{label}</b>: {y} <b>({percentage}%)</b>",
    //         neckWidth: 10,
    //         neckHeight: 0,
    //         valueRepresents: "area",
    //         indexLabelPlacement: "outside",
    //         // indexLabelFontColor:"white",
    //         dataPoints: [
    //             { y: totalGate, label: "Opportunity("+totalGate+")" },
    //             { y: totalProposalSend, label: "Proposal("+totalProposalQuantity+")" },
    //             { y: totalCommercialSend, label: "Commercial("+totalCommercialQuantity+")" },
    //             { y: totalClosureSend, label: "Closure("+totalClosureQuantity+")" }
    //         ]
    //     }]
    // }
    // //calculate percentage
    // dataPoint = canvasOptions.data[0].dataPoints;
    // total = dataPoint[0].y;
    // for(let i = 0; i < dataPoint.length; i++) {
    //     if(i === 0) {
    //         canvasOptions.data[0].dataPoints[i].percentage = 100;
    //     } else {
    //         canvasOptions.data[0].dataPoints[i].percentage = ((dataPoint[i].y / total) * 100).toFixed(2);
    //     }
    // }

    const getrmclick = (e, type) => {
        let stages = [{
            "Open": 1,
            "Suspect":2,
            "Prospect":3,
            "Proposal_Sent":4,
            "Commercial_Negotiation": 5,
            "Commercial_Finalised" : 6,
            "Agreement_Discussion" : 7,
            "Agreement_Signed" : 8,
            "Won-Closed" : 9,
            "Lost-Not_Converted/Dropped" : 10,
            "Client" : 11,
            "Draft" :12,
            "Meeting_Done" : 13
        }];
        if(e.targetID){
            var id = e.targetID.split('#');

            if(id[0] === "legendscrollbutton" || id[0] === 'legend'){
                return false
            }
            let stage = ''
            if(id && id[1]) {
                if(type === 'acc'){
                    stage = pieChartData[(parseInt(id[1])+1)]
                }else{
                    stage = opportunityPieChartData[(parseInt(id[1])+1)]
                    if(stage[0] === 'Won-Closed'){
                        stage[0] = 'Client'
                        stage[1] = 11
                    }
                }

                let stageId = stages[0][stage[0].replace(" ", '_')]
                window.location.href = "pie-list-account/"+stageId
            }
        }
    }
    return (
        <>
            <Loader isLoading={isLoading}/>
            {/*<Sidebar/>*/}
            {/* section start  */}
            <div id="wrapper">
                <DashboardMenu/>
                <div id="content-wrapper" className="d-flex flex-column">
                    <div id="content">
                        <Header
                            history={history}
                        />


                        {/*BODY*/}

                        <div className="container-fluid common-bg">
                            {/*Heading*/}
                            <div className="container-fluid bootstrap snippets bg-white">
                                <div className="d-sm-flex align-items-center justify-content-between mb-4">
                                    <div className="row col-md-12">
                                        <div className="col-md-6 col-sm-6 d-flex mt-20px">
                                            <h1 className="h3 mb-0 text-black-100">Dashboard</h1>
                                        </div>
                                        <div className="col-md-6 cs-pos">
                                            {/* <a href="#"
                                               className="d-none d-sm-inline-block btn btn-sm btn-primary shadow-sm float-right btn-dwn"><i
                                                className="fas fa-download fa-sm"></i><span
                                                className="report-text">&nbsp;Generate Report</span></a> */}
                                            <div className="">
                                                <button onClick={() => setOpen(!open)}
                                                        className="btn btn-sm btn-primary mr-1 btn-filter"
                                                        type="button"><i
                                                    className="fa fa-filter lh-35 pd-3"></i>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {filterView[0] !== undefined && Object.keys(filterView[0]).length > 0 &&
                                    <div className="d-sm-flex align-items-center justify-content-between mt-20px"
                                         style={{marginTop: "36px"}}>
                                        <div className="row pd-filter-div">
                                            <div className="col-md-12 col-sm-12 d-flex">
                                                <div className="applied-filter">
                                                    {Object.keys(filterView[0]).map((val, i) => {
                                                        return (
                                                            <>
                                                            <span className="fd-1">
                                                                <span style={{textTransform: "capitalize"}}>
                                                                    {val.replaceAll("_", " ")}
                                                                </span>
                                                                {" - " + filterView[0][val]}
                                                                <i className="bi bi-x-circle" onClick={(e) => {
                                                                    handleRemoveFilter(val)
                                                                }}></i></span>
                                                            </>
                                                        )
                                                    })}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                }
                                <div className="row">

                                    {/* <div className="col-xl-4 col-md-6">
                                    <div className="card border-left-primary shadow h-130 py-2">
                                        <div className="card-body">
                                            <div className="row no-gutters align-items-center">
                                                <div className="col mr-2">
                                                    <div
                                                        className="text-xs font-weight-bold text-primary text-uppercase mb-1">
                                                        Total Accounts
                                                    </div>
                                                    <div className="h5 mb-0 font-weight-bold text-black-100">130
                                                    </div>
                                                </div>
                                                <div className="col-auto">
                                                    <i className="fas fa-calendar fa-2x text-gray-300"></i>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div> */}

                                    {/* <div className="col-xl-4 col-md-6">
                                    <div className="card border-left-success shadow h-130 py-2">
                                        <div className="card-body">
                                            <div className="row no-gutters align-items-center">
                                                <div className="col mr-2">
                                                    <div
                                                        className="text-xs font-weight-bold text-success text-uppercase mb-1">
                                                        Activities
                                                    </div>
                                                    <div className="h5 mb-0 font-weight-bold text-black-100">121
                                                    </div>
                                                </div>
                                                <div className="col-auto">
                                                    <i className="fas fa-chart-bar fa-2x text-gray-300"></i>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div> */}

                                    {/* <div className="col-xl-4 col-md-6">
                                    <div className="card shadow mb-4 h-130">
                                        <div className="card-header">
                                            <h6 className="m-0 font-weight-bold text-primary">Projects</h6>
                                        </div>

                                            <div className="card-body">
                                                <h4 className="small font-weight-bold text-black-100">Business <span
                                                    className="float-right">50%</span></h4>
                                                <div className="progress mb-4">
                                                    <div className="progress-bar bg-success" role="progressbar"
                                                         style={{"width" : "50%"}}
                                                         aria-valuenow="20" aria-valuemin="0" aria-valuemax="100"></div>
                                                </div>
                                            </div>
                                    </div>
                                </div> */}

                                </div>

                                <div className="row">
                                    {/*END*/}
                                    <div className="col-md-12 col-sm-12">
                                        <div className="card shadow mb-4">
                                        <div className="card-body">
                                                <h4 className="small font-weight-bold text-black-100">Account Win Rate<span
                                                    className="float-right">{dashboardContent?.data?.avg_client_account}%</span></h4>
                                                <div className="progress mb-4">
                                                    <div className="progress-bar bg-success" role="progressbar"
                                                         style={{"width" : `${dashboardContent?.data?.avg_client_account}%`}}
                                                         aria-valuenow="20" aria-valuemin="0" aria-valuemax="100"> 
                                                    </div>
                                                </div>
                                                <hr className="hr-line"/>
                                                <div className="d-flex">
                                                    <div className="sl text-center sl-border">
                                                      <span className="">Total</span>
                                                        <a href={"list-account"}>
                                                            <span>{dashboardContent?.data?.total_account !== undefined ? dashboardContent?.data?.total_account : 0}</span>
                                                        </a>

                                                    </div>
                                                    <div className="sl text-center sl-border">
                                                      <span className="cgs">Open</span>
                                                        <span>{dashboardContent?.data?.meeting_done_account !== undefined ? dashboardContent?.data?.meeting_done_account : 0}</span>
                                                    </div>
                                                    <div className="sl text-center">
                                                     <span className="bgs">Client</span>
                                                        <a href={"pie-list-account/11"}>
                                                            <span>{dashboardContent?.data?.client_account !== undefined ? dashboardContent?.data?.client_account : 0}</span>
                                                        </a>

                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-md-6">
                                        <div className="card shadow mb-4">
                                            <div className="card-body">
                                                <h4 className="small font-weight-bold text-black-100">Funnel</h4>
                                                <div className="d-flex">
                                                    <div className="sl text-center  sl-border">
                                                        <span className="cgs">Opportunities</span>
                                                        <span>{dashboardContent?.data?.total_opportunity !== undefined ? dashboardContent?.data?.total_opportunity : 0}</span>
                                                    </div>
                                                    <div className="sl text-center">
                                                        <span className="cgs">Total Gate Count</span>
                                                        <span>{dashboardContent?.data?.total_quantity !== undefined ? dashboardContent?.data?.total_quantity : 0}</span>
                                                    </div>
                                                </div>
                                                {/*<hr className="hr-line"/>*/}
                                                {/*<div className="d-flex">*/}
                                                    {/*<div className="sl text-center sl-border">*/}
                                                    {/*    <span className="">Gates</span>*/}
                                                    {/*    <span>{dashboardContent?.data?.total_gate !== undefined ? dashboardContent?.data?.total_gate : 0}</span>*/}
                                                    {/*</div>*/}
                                                    {/*<div className="sl text-center">*/}
                                                    {/*    <span className="">Today's Closure</span>*/}
                                                    {/*    <span>{dashboardContent?.data?.closed_account !== undefined ? dashboardContent?.data?.closed_account : 0}</span>*/}
                                                    {/*</div>*/}
                                                {/*</div>*/}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="card shadow mb-4">
                                            <div className="card-body">
                                                <h4 className="small font-weight-bold text-black-100">Today's Closure</h4>
                                                <div className="d-flex">
                                                    <div className="sl text-center  sl-border">
                                                        <span className="cgs">Account</span>
                                                        <span>{dashboardContent?.data?.closed_account !== undefined ? dashboardContent?.data?.closed_account : 0}</span>
                                                    </div>
                                                    <div className="sl text-center">
                                                        <span className="cgs">Gate</span>
                                                        <span>{dashboardContent?.data?.total_closed_gate !== undefined ? dashboardContent?.data?.total_closed_gate : 0}</span>
                                                    </div>
                                            </div>
                                        </div>
                                    </div>
                                    </div>
                                    {/*<div className="col-md-6">*/}
                                    {/*    <div className="card shadow mb-4">*/}
                                    {/*        <CanvasJSChart options = {canvasOptions}*/}
                                    {/*        />*/}
                                    {/*    </div>*/}
                                    {/*</div>*/}
                                    <div className="col-md-6">
                                        <div className="card shadow mb-4">
                                            <div className="card-body">
                                                <h4 className="small font-weight-bold text-black-100"></h4>
                                                <div className="d-flex">
                                                    <div className="sl text-left  sl-border">
                                                        <span className="" style={{color:"#0da8ec"}}><b>Stages</b></span>
                                                    </div>
                                                    <div className="sl text-center sl-border">
                                                        <span className="" style={{color:"#0da8ec"}}><b>Opportunity</b></span>
                                                        {/*<span>{dashboardContent?.data?.total_closed_gate !== undefined ? dashboardContent?.data?.total_closed_gate : 0}</span>*/}
                                                    </div>
                                                    <div className="sl text-center ">
                                                        <span className="" style={{color:"#0da8ec"}}><b>Gates</b></span>
                                                        {/*<span>{dashboardContent?.data?.total_proposal_quantity !== undefined ? dashboardContent?.data?.total_proposal_quantity : 0}</span>*/}
                                                    </div>
                                                </div>
                                                <hr className="hr-line"/>
                                                <div className="d-flex">
                                                    <div className="sl text-left  sl-border">
                                                        <span className=""><b>Proposal</b></span>
                                                    </div>
                                                    <div className="sl text-center sl-border">
                                                        {/*<span className="cgs">Opportunity</span>*/}
                                                        <span>{dashboardContent?.data?.total_proposal_send !== undefined ? dashboardContent?.data?.total_proposal_send : 0}</span>
                                                    </div>
                                                    <div className="sl text-center ">
                                                        {/*<span className="cgs">Gates</span>*/}
                                                        <span>{dashboardContent?.data?.total_proposal_quantity !== undefined ? dashboardContent?.data?.total_proposal_quantity : 0}</span>
                                                    </div>
                                                </div>
                                                <hr className="hr-line"/>
                                                <div className="d-flex">
                                                    <div className="sl text-left  sl-border">
                                                        <span className=""><b>Commercial</b></span>
                                                    </div>
                                                    <div className="sl text-center sl-border">
                                                        {/*<span className="cgs">Opportunity</span>*/}
                                                        <span>{dashboardContent?.data?.total_commercial_send !== undefined ? dashboardContent?.data?.total_commercial_send : 0}</span>
                                                    </div>
                                                    <div className="sl text-center">
                                                        {/*<span className="cgs">Gate</span>*/}
                                                        <span>{dashboardContent?.data?.total_commercial_quantity !== undefined ? dashboardContent?.data?.total_commercial_quantity : 0}</span>
                                                    </div>
                                                </div>
                                                <hr className="hr-line"/>
                                                <div className="d-flex">
                                                    <div className="sl text-left  sl-border">
                                                        <span className=""><b>Closure</b></span>
                                                    </div>
                                                    <div className="sl text-center sl-border">
                                                        {/*<span className="cgs">Opportunity</span>*/}
                                                        <span>{dashboardContent?.data?.total_closure_send !== undefined ? dashboardContent?.data?.total_closure_send : 0}</span>
                                                    </div>
                                                    <div className="sl text-center">
                                                        {/*<span className="cgs">Gate</span>*/}
                                                        <span>{dashboardContent?.data?.total_closure_quantity !== undefined ? dashboardContent?.data?.total_closure_quantity : 0}</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="card shadow mb-4">
                                            <div className="card-body">
                                                <h4 className="small font-weight-bold text-black-100"></h4>
                                                <div className="d-flex">
                                                    <div className="sl text-left  sl-border">
                                                        <span className="" style={{color:"#0da8ec"}}><b>Solution</b></span>
                                                    </div>
                                                    <div className="sl text-center">
                                                        <span className="" style={{color:"#0da8ec"}}><b>Quantity</b></span>
                                                        {/*<span>{dashboardContent?.data?.total_closed_gate !== undefined ? dashboardContent?.data?.total_closed_gate : 0}</span>*/}
                                                    </div>
                                                </div>
                                                {dashboardContent?.data?.lead_gate_types_count !== [] && dashboardContent?.data?.lead_gate_types_count !== undefined &&
                                                    Object.keys(dashboardContent?.data?.lead_gate_types_count).map((val, i) => {
                                                    return (
                                                        <>
                                                            <hr className="hr-line"/>
                                                            <div className="d-flex">
                                                                <div className="sl text-left  sl-border">
                                                                    <span className=""><b>{val}</b></span>
                                                                </div>
                                                                <div className="sl text-center">
                                                                    {/*<span className="cgs">Opportunity</span>*/}
                                                                    <span>{dashboardContent?.data?.lead_gate_types_count[val]}</span>
                                                                </div>
                                                            </div>
                                                        </>
                                                    )
                                                })}

                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="card shadow mb-4">
                                            <div className="card-header">
                                                <h5 className="m-0 font-weight-bold text-primary">Funnel(Till date)</h5>
                                            </div>
                                                <FunnelChart
                                                    data={[
                                                        // { name: 'Opportunity('+totalGate+')',
                                                        //     value: dashboardContent?.data?.total_opportunity !== undefined ? dashboardContent?.data?.total_opportunity : 0},
                                                        { name: 'Proposal('+totalProposalQuantity+')',
                                                                value: dashboardContent?.data?.total_proposal_funnel !== undefined ? dashboardContent?.data?.total_proposal_funnel : 0},
                                                        { name: 'Commercial('+totalCommercialQuantity+')',
                                                            value: dashboardContent?.data?.total_commercial_funnel !== undefined ? dashboardContent?.data?.total_commercial_funnel : 0},
                                                        { name: 'Closure('+totalClosureQuantity+')',
                                                            value: dashboardContent?.data?.total_closure_funnel !== undefined ? dashboardContent?.data?.total_closure_funnel : 0}
                                                    ]}
                                                />
                                            </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="card shadow mb-4">
                                            <div className="card-header">
                                                <h5 className="m-0 font-weight-bold text-primary">Accounts</h5>
                                            </div>
                                            <Chart
                                                chartType="PieChart"
                                                data={pieChartData}
                                                options={options}
                                                width={"100%"}
                                                height={"400px"}
                                                chartEvents={[
                                                    {
                                                        eventName: "ready",
                                                        callback: ({ chartWrapper, google }) => {
                                                            const chart = chartWrapper.getChart();
                                                            google.visualization.events.addListener(chart, "click", e => {
                                                                getrmclick(e, 'acc');
                                                            });
                                                        }
                                                    }
                                                ]}
                                            />
                                        </div>
                                    </div>

                                    <div className="col-md-6">
                                        <div className="card shadow mb-4">
                                            <div className="card-header">
                                                <h5 className="m-0 font-weight-bold text-primary">Opportunity</h5>
                                            </div>
                                            <Chart
                                                chartType="PieChart"
                                                data={opportunityPieChartData}
                                                options={options}
                                                width={"100%"}
                                                height={"400px"}
                                                chartEvents={[
                                                    {
                                                        eventName: "ready",
                                                        callback: ({ chartWrapper, google }) => {
                                                            const chart = chartWrapper.getChart();
                                                            google.visualization.events.addListener(chart, "click", e => {
                                                                getrmclick(e, 'opp');
                                                            });
                                                        }
                                                    }
                                                ]}
                                            />
                                        </div>
                                    </div>
                                    {/*<div className="col-md-6">*/}
                                    {/*    <div className="card shadow mb-4">*/}
                                    {/*        <div className="card-header">*/}
                                    {/*            <h5 className="m-0 font-weight-bold text-primary">Leads</h5>*/}
                                    {/*        </div>*/}
                                    {/*        <Chart*/}
                                    {/*            chartType="ColumnChart"*/}
                                    {/*            width="100%"*/}
                                    {/*            height="400px"*/}
                                    {/*            data={dataBar}*/}
                                    {/*            options={ccOptions}*/}
                                    {/*        />*/}
                                    {/*    </div>*/}
                                    {/*</div>*/}

                                    {/*<div className="col-md-12">*/}
                                    {/*    <div className="card shadow mb-4">*/}
                                    {/*        <Chart*/}
                                    {/*            chartType="Bar"*/}
                                    {/*            width="100%"*/}
                                    {/*            height="400px"*/}
                                    {/*            data={dataMonth}*/}
                                    {/*            options={optionsMonth}*/}
                                    {/*        />*/}
                                    {/*    </div>*/}
                                    {/*</div>*/}

                                </div>


                            </div>
                        </div>

                        {/*END BODY*/}
                    </div>

                </div>
                <BottomMenu
                    open={open}
                    setOpen={setOpen}
                    filterContent={dashboardContent?.data?.filter}
                    handleFilter={handleFilter}
                    handleSubmitFilter={handleSubmitFilter}
                    setIsRemoveFilter={setIsRemoveFilter}
                />
            </div>
            {/* section ends */}
        </>
    )
}

export default Dashboard